import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';

import {
  getHasOnboardedPipelines,
  getRepository,
} from 'src/components/pipelines/redux/selectors/pipelines';
import { useParams, useHistory__UNSAFE } from 'src/router/hooks';
import { LoadingPage } from 'src/sections/global/components/loading-page';

import {
  buildPipelinesRedirect,
  buildQueryRedirect,
} from '../../utils/redirects';

import PipelinesEnvIndicator from './env-indicator';
import Onboarding from './onboarding';
import PipelinesPage from './pipelines-page';
import ResultPage from './result-page';

const PipelinesRoutes = () => {
  const history = useHistory__UNSAFE();
  const { pipelineUuid, repositoryFullSlug } = useParams<{
    pipelineUuid: string;
    repositoryFullSlug: string;
  }>();
  const repository = useSelector(getRepository);
  const hasOnboardedPipelines = useSelector(getHasOnboardedPipelines);
  useEffect(() => {
    // handle Connect URL redirections
    if (history.location.hash.startsWith('#!/')) {
      const pathname = buildPipelinesRedirect(
        history.location.hash,
        repositoryFullSlug
      );
      const search = buildQueryRedirect(history.location.hash, location.search);
      history.replace({ pathname, search });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!repository.hasFetched) {
    return <LoadingPage />;
  }
  if (!hasOnboardedPipelines) {
    return <Onboarding />;
  }
  return (
    <>
      {pipelineUuid ? <ResultPage /> : <PipelinesPage />}
      <PipelinesEnvIndicator />
    </>
  );
};

export default React.memo(PipelinesRoutes);
